"use strict";

var _classCallCheck = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var class_validator_1 = require("class-validator");

var lot_1 = require("./lot");

var AlertTypes;

(function (AlertTypes) {
  AlertTypes["Program"] = "Program";
  AlertTypes["Lot"] = "Lot";
})(AlertTypes = exports.AlertTypes || (exports.AlertTypes = {}));

var FavoritePrivateDTO = function FavoritePrivateDTO() {
  _classCallCheck(this, FavoritePrivateDTO);
};

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], FavoritePrivateDTO.prototype, "id", void 0);

__decorate([class_validator_1.IsEnum(AlertTypes), __metadata("design:type", String)], FavoritePrivateDTO.prototype, "alertType", void 0);

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], FavoritePrivateDTO.prototype, "lotId", void 0);

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], FavoritePrivateDTO.prototype, "programId", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], FavoritePrivateDTO.prototype, "programSlug", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], FavoritePrivateDTO.prototype, "name", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], FavoritePrivateDTO.prototype, "city", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], FavoritePrivateDTO.prototype, "postalCode", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], FavoritePrivateDTO.prototype, "surfaceMin", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], FavoritePrivateDTO.prototype, "surfaceMax", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], FavoritePrivateDTO.prototype, "priceMin", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], FavoritePrivateDTO.prototype, "priceMax", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], FavoritePrivateDTO.prototype, "roomsCountMin", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], FavoritePrivateDTO.prototype, "roomsCountMax", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], FavoritePrivateDTO.prototype, "reference", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], FavoritePrivateDTO.prototype, "price", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], FavoritePrivateDTO.prototype, "surface", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], FavoritePrivateDTO.prototype, "floor", void 0);

__decorate([class_validator_1.IsEnum(lot_1.LotTypes), __metadata("design:type", String)], FavoritePrivateDTO.prototype, "type", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], FavoritePrivateDTO.prototype, "roomsCount", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], FavoritePrivateDTO.prototype, "southExposition", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], FavoritePrivateDTO.prototype, "northExposition", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], FavoritePrivateDTO.prototype, "eastExposition", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], FavoritePrivateDTO.prototype, "westExposition", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], FavoritePrivateDTO.prototype, "balconySurface", void 0);

__decorate([class_validator_1.IsEnum(lot_1.ParkingTypes), __metadata("design:type", String)], FavoritePrivateDTO.prototype, "parkingType", void 0);

__decorate([class_validator_1.IsUrl(), __metadata("design:type", String)], FavoritePrivateDTO.prototype, "picture", void 0);

exports.FavoritePrivateDTO = FavoritePrivateDTO;

var FavoriteCreationDTO = function FavoriteCreationDTO() {
  _classCallCheck(this, FavoriteCreationDTO);
};

__decorate([class_validator_1.IsUUID(), class_validator_1.IsOptional(), __metadata("design:type", String)], FavoriteCreationDTO.prototype, "lotId", void 0);

__decorate([class_validator_1.IsUUID(), class_validator_1.IsOptional(), __metadata("design:type", String)], FavoriteCreationDTO.prototype, "programId", void 0);

exports.FavoriteCreationDTO = FavoriteCreationDTO;